import {
	getIsUpdateSeatsModalVisible,
	setIsUpdateSeatsModalVisible
} from "~/solidJs/shared/models/globalStores";

export const openUpdateSeatsModal = () => {
	setIsUpdateSeatsModalVisible(true);
};

export const closeUpdateSeatsModal = () => {
	setIsUpdateSeatsModalVisible(false);
};

export const isUpdateSeatsModalVisible = () => getIsUpdateSeatsModalVisible();
